<aside class="sidebar-inner">
    <div class="logo-wrapper">
        <a href="javascript:void(0)" class="logo">
            <img class="logo-default" [src]="brandLogo" alt="Crizac" title="Crizac" />
            <img class="logo-icon" [src]="brandLogoIcon" alt="Crizac" title="Crizac" />
        </a>
    </div>

    <div class="logo-wrapper">
        <a href="javascript:void(0)" class="logo">
            <img class="logo-default" [src]="brandLogo" alt="Crizac" title="Crizac" />
        </a>
    </div>

    <button mat-flat-button class="btn-compose-mail mt-12" (click)="openComposeMail()">
        <img src="./assets/images/compose-mail-icon-white.svg" alt="Compose Mail">
        <span class="txt">Compose Mail</span>
    </button>
    <button mat-stroked-button class="btn-outline-secondary meeting-event-btn" (click)="createMeetingEvent()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            style="margin-right: 8px; vertical-align: middle; flex-shrink: 0;">
            <rect x="1" y="2" width="14" height="13" rx="2" stroke="currentColor" stroke-width="1.2" />
            <path d="M5 1v3M11 1v3M1 6h14" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
            <rect x="4" y="8.5" width="2" height="2" rx="0.4" fill="currentColor" />
            <rect x="7" y="8.5" width="2" height="2" rx="0.4" fill="currentColor" />
            <rect x="10" y="8.5" width="2" height="2" rx="0.4" fill="currentColor" />
        </svg>
        <span class="txt">Create Invitation</span>
    </button>
    <mat-accordion class="mat-accordion" multi="false">
        <mat-expansion-panel *ngIf="userAccounts.length > 1" [expanded]="true" (opened)="panelOpenState.set(true)"
            (closed)="panelOpenState.set(false)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <img class="icon normal" src="./assets/images/mailbox-icon-gray.svg" alt="Inbox" />
                    <img class="icon active" src="./assets/images/mailbox-icon-orange.svg" alt="Inbox" />
                    <span class="label">All Mails</span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="expansion-content mail-btns-group">
                <ng-container *ngFor="let folder of allMailFolders">
                    <button mat-button *ngIf="folder.label !== 'Personal Mail' && folder.label !== 'Shared With Me'"
                        [class.active]="selectedFolder === folder.label && selectedEmail === allMailsEmail"
                        (click)="goToMail(folder.label, folder.type, allMailsDomain, allMailsEmail, userType)">
                        <span class="icon-group">
                            <img class="icon normal" [src]="'./assets/images/' + folder?.image + '-icon-gray.svg'"
                                alt="Inbox" />
                            <img class="icon active" [src]="'./assets/images/' + folder?.image + '-icon-orange.svg'"
                                alt="Inbox" />
                        </span>
                        {{ folder.label }}
                        <span class="counter" *ngIf="folder.countKey && dashboardData?.[folder.countKey]">
                            {{ dashboardData[folder.countKey] }}
                        </span>
                        @if (folder.countKey && !dashboardDataError && (!dashboardData ||
                        dashboardData?.[folder.countKey] === undefined)) {
                        <span class="loader-counter">
                            <ng-lottie [options]="lottieOptions" width="30px" height="30px">
                            </ng-lottie>
                        </span>
                        }

                    </button>
                </ng-container>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel *ngFor="let account of userAccounts; let i = index"
            [expanded]="userAccounts.length === 1 && i === 0"
            (opened)="onPanelOpened(account?.mail, false, account?.domain, account?.isPersonal)">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <img class="icon normal" src="./assets/images/mailbox-icon-gray.svg" alt="Inbox" />
                    <img class="icon active" src="./assets/images/mailbox-icon-orange.svg" alt="Inbox" />
                    <span class="label text-nowrap" [matTooltip]="account?.mail?.length > 20 ? account?.mail : ''"
                        matTooltipPosition="above" matTooltipShowDelay="300">
                        {{
                        account?.mail?.length > 20
                        ? (account?.mail | slice: 0:20) + '…'
                        : account?.mail
                        }}</span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="expansion-content mail-btns-group">
                <ng-container *ngFor="let folder of allMailFolders">
                    <button mat-button
                        *ngIf="(userType && account?.isPersonal === 'true') || folder.label !== 'Personal Mail'"
                        [class.active]="selectedFolder === folder.label && selectedEmail === account?.mail"
                        (click)="goToMail(folder.label, folder.type, account?.domain, account?.mail, userType, account?.isPersonal)">
                        <span class="icon-group">
                            <img class="icon normal" [src]="'./assets/images/' + folder?.image + '-icon-gray.svg'"
                                alt="Inbox" />
                            <img class="icon active" [src]="'./assets/images/' + folder?.image + '-icon-orange.svg'"
                                alt="Inbox" />
                        </span>
                        {{ folder.label }}
                        <span class="counter"
                            *ngIf="folder.countKey && dashboardDataMap[account?.mail]?.[folder.countKey]">
                            {{ dashboardDataMap[account?.mail][folder.countKey] }}
                        </span>
                        @if (folder.countKey && !dashboardDataMapError[account?.mail] &&
                        (!dashboardDataMap[account?.mail] || dashboardDataMap[account?.mail]?.[folder.countKey] ===
                        undefined)) {
                        <span class="loader-counter">
                            <ng-lottie [options]="lottieOptions" width="30px" height="30px">
                            </ng-lottie>
                        </span>
                        }
                    </button>
                </ng-container>

                <!-- Custom Tags for this account -->
                <ng-container *ngIf="(account.createFolderAccess === 'true' || account.createFolderAccess === true)">
                    <div class="sidebar-section-header">Tags</div>

                    <button mat-button (click)="createNewTag(account.mail)" class="btn-add-tag-inline">
                        <span class="icon-group">
                            <mat-icon class="fs-18">add</mat-icon>
                        </span>
                        Create New Tag
                    </button>

                    <button mat-button *ngFor="let tag of getAccountTags(account.mail)"
                        [class.active]="selectedTagId === tag.id && selectedEmail === account.mail"
                        (click)="goToTag(tag, account.mail)" class="tag-folder-btn" (dragover)="onDragOver($event)"
                        (dragleave)="onDragLeave($event)" (drop)="onDrop($event, tag)">
                        <span class="icon-group">
                            <mat-icon class="fs-18">label_outline</mat-icon>
                        </span>
                        <span class="tag-name">{{ tag.name }}</span>
                        <span class="tag-actions">
                            <mat-icon class="fs-16 mr-1 icon-edit" (click)="renameTag($event, tag)"
                                matTooltip="Rename">edit</mat-icon>
                            <mat-icon class="fs-16 icon-delete" (click)="deleteTag($event, tag)"
                                matTooltip="Delete">delete_outline</mat-icon>
                        </span>
                    </button>
                </ng-container>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <app-footer></app-footer>
</aside>

<!-- Compose-style popup — sits at bottom-right of screen -->
<app-create-meeting-event *ngIf="showMeetingEvent" (closed)="showMeetingEvent = false"
    (saved)="onMeetingEventSaved($event)">
</app-create-meeting-event>